import React, { useState, useEffect } from 'react';
import styles from '../BasicCleanupsFilter.module.scss';
import { CalciteCheckbox } from '@esri/calcite-components-react';

let checkAll = false;
const BasicResponseAuthorityFilter = (props) => {
  const [checkboxDivArray, setCheckboxDivArray] = useState<Array<any>>([]);
  const [checkAllCheckbox, setCheckAllCheckbox] = useState<Array<any>>([]);
        const options = {
        "*CERCLA": {
            param: "EPAOSC_RESP_AUTH='CERCLA'",
            isIncluded: false,
            objectIds: null
        },  
        "*CERCLA/*OPA": {
            param: "EPAOSC_RESP_AUTH='CERCLA/OPA'",
            isIncluded: false,
            objectIds: null
        },  
        "*CWA": {
            param: "EPAOSC_RESP_AUTH='CWA'",
            isIncluded: false,
            objectIds: null
        },  
        "*OPA": {
            param: "EPAOSC_RESP_AUTH='OPA'",
            isIncluded: false,
            objectIds: null
        },  
        "Stafford Act": {
            param: "EPAOSC_RESP_AUTH='STAFFORD ACT'",
            isIncluded: false,
            objectIds: null
        },
        "No Category": {
          param: "(EPAOSC_RESP_AUTH = 'No Category')",
          isIncluded: false,
          objectIds: null
      }
    }

    const toggleAll = () => {
      // switch checkAll
      checkAll = !checkAll;
      for (let option in options) {
  
        if (checkAll) {
          // set all isIncludeds to false so they can be set to true from buildCheckBoxDivs()
          options[option]["isIncluded"] = false;
        } else if (!checkAll) {
          // switch all isIncludeds to true so they can be switched back to false by toggleParam()
          options[option]["isIncluded"] = true;
          toggleParam(option);
        }
      }
      buildCheckboxDivs();
    }
  
    const toggleParam = async (key) => {
      options[key].isIncluded = !options[key].isIncluded;
      passUpdatedParams();
    }
  
    const passUpdatedParams = () => {
      let paramArray: Array<any> = [];
      for (let option in options) {
        if (options[option].isIncluded === true) {
          paramArray.push(options[option].param)
        }
      }
      props.updateResponseAuthorityParams(paramArray);
    }
  
    const buildCheckAllCheckboxDiv = () => {
      let checkAllDiv;
      if (!checkAll) {
        checkAllDiv =
          <div className={styles.SectionTitleDivs}>
            <CalciteCheckbox name={"toggleAllResponseAuthority"} onCalciteCheckboxChange={() => { toggleAll() }} key={Math.random()} />
            <label className={styles.FilterSectionLabels}>Response Authority</label>
          </div>;
      } else if (checkAll) {
        checkAllDiv =
          <div className={styles.SectionTitleDivs}>
            <CalciteCheckbox checked name={"toggleAllResponseAuthority"} onCalciteCheckboxChange={() => { toggleAll() }} key={Math.random()} />
            <label className={styles.FilterSectionLabels}>Response Authority</label>
          </div>;
        // toggleAll();
      }
      setCheckAllCheckbox(checkAllDiv);
    }
  
    const buildCheckboxDivs = () => {
      let tempArr: Array<any> = [];
      if (!checkAll) {
        for (let key in options) {
          tempArr.push(
            <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
              <CalciteCheckbox name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
              <label className={styles.CheckboxLabels}>{key}</label>
            </div>
          );
        }
      } else if (checkAll) {
        for (let key in options) {
          toggleParam(key);
          tempArr.push(
            <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
              <CalciteCheckbox checked name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
              <label className={styles.CheckboxLabels}>{key}</label>
            </div>
          );
        }
      }
      setCheckboxDivArray(tempArr);
    }
  
    useEffect(() => { }, [checkboxDivArray]);
  
    useEffect(() => {
      if (props.checkAllBoxes === true) {
        checkAll = true;
      } else if (props.checkAllBoxes === false || props.checkAllBoxes === undefined) {
        checkAll = false;
      }
      buildCheckAllCheckboxDiv();
      buildCheckboxDivs();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.signalAChange]);
  
    return (
      <div className={styles.Sections}>
        {checkAllCheckbox}
        <div className={styles.CheckboxSectionDivs}>
          {checkboxDivArray}
        </div>
      </div>
    );
  
  }

export default BasicResponseAuthorityFilter;
